import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Helmet from '../components/Helmet/Helmet';
import AboutSection from '../components/UI/AboutSection';
import CommonSection from '../components/UI/CommonSection';
import driveImg from '../assets/all-images/drive.jpg'
import BecomeDriverSection from '../../src/components/UI/BecomeDriverSection'
import OurMembers from '../components/UI/OurMembers';

const About = () => {
    return (
       <Helmet title="About">
        <CommonSection title="Terms & Condition"/>

        <section className="about__page-section">
            <Container>
                <Row>
                    

                    <Col lg='12' md='12' sm='12'>
                        <div><div class="bg-light py-3"><div class="container"><div class="row"><div class="col-md-12 mb-0"><a href="/">Home</a> <span class="mx-2 mb-0">/</span> <strong class="text-black">Term &amp; Conditions</strong></div></div></div></div><div class="container" style={{width: "99%", padding: "80px 30px"}}><div class="row"><div class="col-xl-12 col-lg-12 col-md-12"><div style={{fontWeight: "bold"}}><h2>Terms And Conditions</h2><p>These Terms of Use (“Terms”) govern the access or use by you, an individual, from within any country in the world of applications, websites, content, products, and services (the “Services”) made available by Rent A Car., a limited liability partnership established in Pakistan registered at the Federal Board of Revenue under the NTN # [NTN Number]</p><p class="intro">PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE SERVICES.</p><p>Your access and use of the Services constitutes your agreement to be bound by these Terms, which establishes a contractual relationship between you and Rent A Car. If you do not agree to these Terms, you may not access or use the Services. These Terms expressly supersede prior agreements or arrangements with you. Rent A Car may immediately terminate these Terms or any Services with respect to you, or generally cease offering or deny access to the Services or any portion thereof, at any time for any reason.</p><h2>Supplemental terms</h2><p>Supplemental terms may apply to certain Services, such as policies for a particular event, activity or promotion, and such supplemental terms will be disclosed to you in connection with the applicable Services. Supplemental terms are in addition to, and shall be deemed a part of, the Terms for the purposes of the applicable Services. Supplemental terms shall prevail over these Terms in the event of a conflict with respect to the applicable Services.</p><h2>Amendments to Terms</h2><p>Rent A Car may amend the Terms related to the Services from time to time. Amendments will be effective upon Rent A Car’s posting of such ated Terms at this location or the amended policies or supplemental terms on the applicable Service. Your continued access or use of the Services after such posting constitutes your consent to be bound by the Terms, as amended.</p></div></div></div></div></div>
                    </Col>
                </Row>
            </Container>
        </section>
        <BecomeDriverSection/>

        {/* <section>
            <Container>
                <Row>
                    <Col lg='12' className='mb-5 text-center'>
                        <h6 className="section__subtitle">Experts</h6>
                        <h2 className="section__title">Our Members</h2>
                    </Col>
                    <OurMembers></OurMembers>
                </Row>
            </Container>
        </section> */}
<br />
       </Helmet>
    );
};

export default About;


